import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { StoreDevtoolsName } from '../store-names.const'

import { notificationsInitialState } from './notifications.slice'
import type { NotificationsStore } from './notifications.type'

export const useNotificationsStore = create<NotificationsStore>()(
  devtools(
    immer((set) => ({
      ...notificationsInitialState,
      markAsRead: (id) =>
        set((state) => {
          const notification = state.notifications.find((item) => item.id === id)
          if (notification) {
            notification.isRead = true
          }
        }),
      markAllAsRead: () =>
        set((state) => {
          state.notifications.forEach((notification) => {
            notification.isRead = true
          })
        }),
      dismissNotification: (id) =>
        set((state) => {
          state.notifications = state.notifications.filter((notification) => notification.id !== id)
        }),
      clearAll: () =>
        set((state) => {
          state.notifications = []
        }),
    })),
    { name: StoreDevtoolsName.Notifications, enabled: process.env.NODE_ENV === 'development' }
  )
)
